var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 135,
    viewBox: "0 0 133 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 45,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F8F2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29890_73247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0625 75.4133L71.957 74.0813C74.4492 72.3625 76.125 69.4836 76.125 66.175C76.125 60.8899 71.7852 56.55 66.5 56.55C61.1719 56.55 56.875 60.8899 56.875 66.175C56.875 69.4836 58.5078 72.3625 61 74.0813L58.8945 75.4133C58.4648 75.6711 58.25 76.1008 58.25 76.5735V77.218C58.25 77.9485 58.8516 78.55 59.625 78.55H73.375C74.1055 78.55 74.75 77.9485 74.75 77.175V76.5735C74.75 76.1008 74.4922 75.6711 74.0625 75.4133ZM66.5 73.05C62.6758 73.05 59.582 69.9993 59.582 66.218C59.582 62.4797 62.6758 59.343 66.457 59.343C70.1953 59.343 73.332 62.4368 73.332 66.218C73.332 70.0422 70.2812 73.05 66.5 73.05ZM66.5 60.675C63.4492 60.675 60.957 63.1672 60.957 66.175C60.957 69.2258 63.4492 71.675 66.457 71.675C69.5078 71.675 71.957 69.2258 71.957 66.175C71.957 63.1672 69.5078 60.675 66.5 60.675ZM66.457 64.1125C65.3398 64.1125 64.4375 65.0579 64.3945 66.175C64.3945 66.5618 64.0938 66.8625 63.707 66.8625C63.3633 66.8625 63.0195 66.5618 63.0195 66.175C63.0625 64.2844 64.5664 62.7375 66.457 62.7375C66.8438 62.7375 67.1445 63.0813 67.1445 63.425C67.1445 63.8118 66.8438 64.1125 66.457 64.1125Z",
    fill: "#A0438B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29890_73247",
    x: 0.625,
    y: 0.300049,
    width: 131.75,
    height: 134.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29890_73247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29890_73247",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvPink);
export default __webpack_public_path__ + "static/media/tv-pink.4b318818.svg";
export { ForwardRef as ReactComponent };